import React from 'react';
import { Typography, Grid, Button } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import T from 'i18n';
import { CustomViewerButton } from 'features/common';
import Tooltip from 'features/common/SimpleTooltip';

const useStyles = makeStyles((theme: any) =>
  createStyles({
    screenShareBanner: {
      zIndex: 8,
      position: 'absolute',
      width: '100%',
      height: '108px',
      background: 'rgba(0, 0, 0, 0.5)',
      '& h6': {
        color: 'white',
      },
      pointerEvents: 'none',
      '& button': {
        pointerEvents: 'all',
        background: 'white',
        color: theme.brand,
        border: `2px solid ${theme.brand}`,
        margin: '0 2em',
        '&:hover': {
          color: '#600101',
          border: `2px solid #600101`,
          background: '#FFE9E7',
        },
      },
      [theme.breakpoints.down('sm')]: {
        bottom: `${theme.trialViewFooterHeight + theme.mobileFooterHeight}px`,
      },
    },
  }),
);

export default ({
  unpauseTheatreMode,
  disconnectPauseTheatreMode,
  hardDisconnectOnlyHearingRoom,
  isDisconnected,
}: {
  unpauseTheatreMode: (e: any) => void;
  disconnectPauseTheatreMode: () => void;
  hardDisconnectOnlyHearingRoom: boolean;
  isDisconnected: boolean;
}) => {
  const classes = useStyles();

  if (hardDisconnectOnlyHearingRoom && !isDisconnected) {
    return (
      <div className="viewing-custom-viewer-toolbox">
        <div className="document-options top-left">
          <Tooltip title={T.translate('viewing.hardDisconnectButtonTooltip')}>
            <CustomViewerButton
              onClick={() => disconnectPauseTheatreMode()}
              style={{ height: 'inherit', width: 'inherit', padding: 'revert' }}
            >
              {T.translate('viewing.hardDisconnectButton')}
            </CustomViewerButton>
          </Tooltip>
        </div>
      </div>
    );
  } else
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={classes.screenShareBanner}
      >
        <Typography variant="h6">
          {T.translate(isDisconnected ? 'viewing.disconnected' : 'viewing.paused')}
        </Typography>
        {isDisconnected ? (
          <Button
            onClick={(e) => {
              unpauseTheatreMode(e);
            }}
          >
            {T.translate('viewing.reconnect')}
          </Button>
        ) : (
          <Button
            onClick={() => {
              disconnectPauseTheatreMode();
            }}
          >
            {T.translate('viewing.disconnect')}
          </Button>
        )}
      </Grid>
    );
};
